import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { PoliciesService } from 'src/app/providers/policy/policies.service';
import { ExcelService } from 'src/app/service/excelService/excel.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { GeneralService } from 'src/app/providers/general/general.service';

declare let $: any;

@Component({
  selector: 'app-covid19',
  templateUrl: './covid19.component.html',
  styleUrls: ['./covid19.component.scss']
})
export class Covid19Component implements OnInit {

  dashBoard: any = [];
  accomondationForm;
  submit=false;
  response: any;
  empData: any;
  loading = false;


  constructor(private polcyServ: PoliciesService,
              private dashboardService: DashboardService,
              private notifyService: NotificationService,
              private router: Router,
              private formBuilder:FormBuilder,
              private httpDash: DashboardService,
              private httpGen: GeneralService,
              private excelServ: ExcelService) { }

  ngOnInit(): void {
    this.accomondationFormField();
    this.getLoggedInEmpDetails();
    this.getDash();
  }
  get covid() { return this.accomondationForm.controls; }

  ssoLogin(link): void {
    this.httpGen.ssoLogin({from:link}).subscribe(res=>{
      this.response = res ;
      if(this.response.data.status==1){
        window.open(this.response.data.url, "_blank");
      }else{
        this.notifyService.showError(this.response.data.msg);
      }
    },
    err => {
      this.notifyService.showError('Internal Server Error!');
    })
  }
  getDash(): void {
    // tslint:disable-next-line: deprecation
    this.polcyServ.getsbTopicData({tpcID: ''}, 5).subscribe(res => {
      if (res.status) {
        this.dashBoard = res.data[0].subtpcs;
      } else {
        this.notifyService.showInfo(res.msg, 'Info!');
      }
    });
  }

  wpReport(): void {
    this.httpDash.permissionReport().subscribe(res => {
      if (res.status) {
        const header = res.header;
        const reportData = {
          title: 'Work Permission Report',
          data: res.data,
          headers: Object.values(header)
        };
        this.excelServ.exportKudosDump(reportData);
      } else {
        this.notifyService.showInfo(res.msg, 'Info!');
      }
    });
  }

  vdReport():void{
    // console.log("vaccination declaration");
    // this.httpDash.vacinDeclareReport().subscribe(res => {
    //   if (res.status) {
    //     const header = res.header;
    //     const reportData = {
    //       title: 'Vaccin Declare Report',
    //       data: res.data,
    //       headers: Object.values(header)
    //     };
    //     this.excelServ.exportKudosDump(reportData);
    //   } else {
    //     this.notifyService.showInfo(res.msg, 'Info!');
    //   }
    // });
  }


  iconDetail(data): void {
    console.log(data);
    if (data.value == 111) {
      this.router.navigateByUrl('/queries/create');
    } else if (data.value == 121) {
      this.router.navigateByUrl('/queries/create');
    } else if (data.value == 125) {
      this.router.navigateByUrl('/leaves');
    } else if (data.value == 124) {
      this.router.navigateByUrl('/queries/create');
    } else if (data.value == 129) {
      this.router.navigateByUrl('/appraisal');
    } else {
      window.open(data.attachment, '_blank');
    }
  }

  openModal(id): void {
    // $(id).modal({ backdrop: 'static', keyboard: false });
    // console.log("open model");
  }

  closeModal(): void {
    this.submit = false;
    // this.accomondationForm.reset();
  }
  accomondationFormField(): void {
    this.accomondationForm = this.formBuilder.group({
      onbelf_emp:[''],
      emp_nm:['',Validators.required],
      cc_id:['',Validators.required],
      user_id:['',Validators.required],
      region:[''],
      accom_address:['',Validators.required],
      staff_stay:['',Validators.required],
      sq_feet:[''],
      remarks:['',Validators.required]
    });
  }
  getLoggedInEmpDetails(): void {
    this.dashboardService.getLoggedInEmpDetails().subscribe( res => {
        this.response = res;
        this.empData = this.response.data;
        this.accomondationForm.patchValue({
          emp_nm: this.empData.emp_name,
          cc: this.empData.cc_desc,
          desig: this.empData.desig_desc,
          depart: this.empData.dept_desc,
          rm: this.empData.rm_name,
          mobile: this.empData.mobile,
          user_id: this.empData.username
        });
    });
  }

  submitAccomondationData(): void {
    this.submit = true;
    if (this.accomondationForm.invalid) {
      return;
    } else {
      const tmp = this.accomondationForm.value.qus;
      const accomondationForm = new FormData();
      accomondationForm.append('user_id', this.accomondationForm.get('user_id').value);
      accomondationForm.append('onbelf_emp', this.accomondationForm.get('onbelf_emp').value);
      accomondationForm.append('emp_nm', this.accomondationForm.get('emp_nm').value);
      accomondationForm.append('cc_id', this.accomondationForm.get('cc_id').value);
      accomondationForm.append('user_id', this.accomondationForm.get('user_id').value);
      accomondationForm.append('region', this.accomondationForm.get('region').value);
      accomondationForm.append('accom_address', this.accomondationForm.get('accom_address').value);
      accomondationForm.append('staff_stay', this.accomondationForm.get('staff_stay').value);
      accomondationForm.append('sq_feet', this.accomondationForm.get('sq_feet').value);
      accomondationForm.append('remarks', this.accomondationForm.get('remarks').value);


      this.dashboardService.addWorkplacepermissio(accomondationForm).subscribe(res => {
      this.loading = false;
      this.submit = false;
      if (res.status) {
        // this.reset();
        // this.location.back();
        this.notifyService.showSuccess(res.msg, 'Success!');
      } else {
        this.notifyService.showInfo(res.msg, 'Info!');
      }
    }, err => {
      this.loading = false;
      this.submit = false;
    });
    }
  }
}
